export enum FeatureFlags {
    OrganizationBasedClinicJoin = 1,
    SQLBasedCustomerSearch = 3,
    AllowSettingVisitTag = 4,
    AllowAppointments = 5,
    AllowOpeningFutureClinics = 6,
    VisitObservations = 7,
    ReferralsandRecommendations = 8,
    IHD = 9,
    AbortVisit = 10,
    AllowVisitSalesItemOptionUpdates = 11,
    PnpNewOrder = 12
}
